module.exports = __webpack_public_path__ + "img/subject-title.31db8917.png";